import { type MiddlewareContext } from 'vue-middleware'
import {useAuthStore} from "@/composables/auth"
import {useRoute, useRouter} from "vue-router";

export default ({ redirect }: MiddlewareContext) => {
    const route = useRoute();
    const router = useRouter();

    const authStore = useAuthStore();
    if (!authStore.authenticated && route.name !== 'login') {
        router.push({name: 'login'})
    }
}